import React from 'react';
import { Column, Section, Title, Container } from "rbx";
import '../../styles/layout.scss';
import HeaderLogged from "../../components/components/HeaderLogged";

const Layout = (props) => {

  return (
    <>
      <HeaderLogged />
      <Section size="medium" className="layout">
        <Container className='is-max-widescreen'>
          <Column.Group breakpoint="mobile" vcentered>
            <Column>
              <Title size={4} className='has-text-grey'>
                {props.controllerName}
              </Title>
            </Column>
            <Column textAlign='right'>
              <Title subtitle size={6} className='has-text-grey'>
                {props.breadcrumb}
              </Title>
            </Column>
          </Column.Group>          
          <Column.Group centered>
            <Column>
              {props.children}
            </Column>
          </Column.Group>
        </Container>
      </Section>
    </>
  )

}

export default Layout;
